import { useEffect } from "react";
import { SquaayRiderAndroidLink, SquaayRiderIOSLink } from "../../common/constant";
import "./RiderDownloadRedirect.css";

const ANDROID_URL = SquaayRiderAndroidLink;
const IOS_URL = SquaayRiderIOSLink;
const FALLBACK_URL = "/download-riders-options";

const detectDevice = () => {
  const ua = navigator.userAgent || navigator.vendor;

  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";

  return "other";
};

export default function RiderDownloadRedirect() {
  useEffect(() => {
    const device = detectDevice();

    if (device === "android") {
      window.location.replace(ANDROID_URL);
    } else if (device === "ios") {
      window.location.replace(IOS_URL);
    } else {
      window.location.replace(FALLBACK_URL);
    }
  }, []);

  return (
    <div className="rider-download-redirect-container">
      <div className="rider-download-redirect-blobs">
        <div className="rider-download-redirect-blob rider-download-redirect-blob-1"></div>
        <div className="rider-download-redirect-blob rider-download-redirect-blob-2"></div>
      </div>

      <div className="rider-download-redirect-content">
        <div className="rider-download-redirect-loading">
          <div className="rider-download-redirect-logo">🏍️</div>
          <div>
            <h2 className="rider-download-redirect-title">Redirecting to App Store</h2>
            <p className="rider-download-redirect-subtitle">
              Taking you to download Squaay Riders
            </p>
            <div className="status-badge status-loading">REDIRECTING</div>
          </div>
          <div className="rider-download-redirect-spinner">
            <div className="rider-download-redirect-spinner-dot"></div>
            <div className="rider-download-redirect-spinner-dot"></div>
            <div className="rider-download-redirect-spinner-dot"></div>
          </div>
          <p className="rider-download-redirect-message">
            ⏱️ This usually takes just a moment. If nothing happens, you'll be taken to our download page.
          </p>
        </div>
      </div>
    </div>
  );
}
